import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
/**
 * Analytics Context provides ways to get the Analytics instance in any of our components,
 * without passing Analytics instance from parent to child components (Avoids prop-drilling)
 *
 * To use Analytics instance,
 *
 * First, wrap the parent component, which has the Analytics instance with Analytics Provider
 * ```
 * <AnalyticsProvider value={Analytics}>
 *  <ParentComponent />
 * </AnalyticsProvider>
 * ```
 * and then, use Analytics instance in any of the child component as:
 * ```
 * const Analytics = useAnalytics();
 * ```
 * to your component
 */
export const AnalyticsContext = createContext({ Analytics: null });

export const useAnalytics = () => {
  const { Analytics } = useContext(AnalyticsContext);
  return Analytics;
};

const AnalyticsProvider = (props) => {
  const { Analytics, children } = props;

  return (
    <AnalyticsContext.Provider value={{ Analytics }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

AnalyticsProvider.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
    page: PropTypes.func,
    purchase: PropTypes.func,
    setUser: PropTypes.func,
    schedule: PropTypes.func,
    venuePixel: PropTypes.func,
    offersLastTouch: PropTypes.func,
    marketingCustomPage: PropTypes.func,
    tddInit: PropTypes.func,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

AnalyticsProvider.displayName = 'AnalyticsProvider';
export default AnalyticsProvider;
